/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseSplitPanelFragment, SplitPanelFragment, FullSplitPanelFragment} from '@amblique/contentful/app/contentful/fragments/split-panel';

/**
 * Get a single SplitPanel by ID (base - scalars only)
 */
export const getBaseSplitPanelById = gql`
  ${BaseSplitPanelFragment}

  query GetBaseSplitPanelById($id: String!, $locale: String!, $preview: Boolean) {
    splitPanel(id: $id, locale: $locale, preview: $preview) {
      ...BaseSplitPanelFragment
    }
  }
`;

/**
 * Get a single SplitPanel by ID (standard - 1 level deep)
 */
export const getSplitPanelById = gql`
  ${SplitPanelFragment}

  query GetSplitPanelById($id: String!, $locale: String!, $preview: Boolean) {
    splitPanel(id: $id, locale: $locale, preview: $preview) {
      ...SplitPanelFragment
    }
  }
`;

/**
 * Get a single SplitPanel by ID (full - 2 levels deep)
 */
export const getFullSplitPanelById = gql`
  ${FullSplitPanelFragment}

  query GetFullSplitPanelById($id: String!, $locale: String!, $preview: Boolean) {
    splitPanel(id: $id, locale: $locale, preview: $preview) {
      ...FullSplitPanelFragment
    }
  }
`;

/**
 * Get all SplitPanel entries with pagination (base - scalars only)
 */
export const getBaseSplitPanels = gql`
  ${BaseSplitPanelFragment}

  query GetBaseSplitPanels(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SplitPanelOrder]
    $where: SplitPanelFilter
    $preview: Boolean
  ) {
    splitPanelCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseSplitPanelFragment
      }
    }
  }
`;

/**
 * Get all SplitPanel entries with pagination (standard - 1 level deep)
 */
export const getSplitPanels = gql`
  ${SplitPanelFragment}

  query GetSplitPanels(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SplitPanelOrder]
    $where: SplitPanelFilter
    $preview: Boolean
  ) {
    splitPanelCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...SplitPanelFragment
      }
    }
  }
`;

/**
 * Get all SplitPanel entries with pagination (full - 2 levels deep)
 */
export const getFullSplitPanels = gql`
  ${FullSplitPanelFragment}

  query GetFullSplitPanels(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SplitPanelOrder]
    $where: SplitPanelFilter
    $preview: Boolean
  ) {
    splitPanelCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullSplitPanelFragment
      }
    }
  }
`;
